import { useSelector } from 'react-redux';
import { useState } from 'react';
import { GeneralSubscription } from '@mews-commander/data-access';
import { Card, SmallContentContainer } from '@mews-commander/ui';
import { Button, IconName, Body, Title, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { mailAddress } from '@mews-commander/assets';
import { MewsImage } from '@mews/business-components';
import { getCurrentEnterpriseSubscription } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { EmailSenderFormValues, EmailSenderForm } from './EmailSenderForm';

interface AddEmailSenderPageProps {
    onSubmit: (values: EmailSenderFormValues) => void;
}

export const AddEmailSenderPage = ({ onSubmit }: AddEmailSenderPageProps) => (
    <SmallContentContainer>
        <Card>
            <AddEmailSenderPageContent onSubmit={onSubmit} />
        </Card>
    </SmallContentContainer>
);

const EmailImage = () => <MewsImage src={mailAddress} />;

const AddEmailSenderPageContent = ({ onSubmit }: AddEmailSenderPageProps) => {
    const { packageOptions }: GeneralSubscription = useSelector(getCurrentEnterpriseSubscription);
    const [showForm, setShowForm] = useState(false);

    if (!packageOptions.customDomainEmailCommunicationsEnabled) {
        return <UpgradeContent />;
    }

    if (!showForm) {
        return <WelcomeContent onAdd={() => setShowForm(true)} />;
    }

    return <EmailSenderForm form="email-sender-add-form" onSubmit={onSubmit} />;
};

const UpgradeContent = () => (
    <Stack vertical spacing="400" itemAlignment="center">
        <Title level={2} align="center">
            <LocalizedText textKey={TextKey.UpgradeToSenderAddress} />
        </Title>
        <StackItem>
            <EmailImage />
        </StackItem>
        <Body align="center">
            <LocalizedText textKey={TextKey.UpgradeToSenderAddressDescription} />
        </Body>
    </Stack>
);

interface WelcomeContentProps {
    onAdd: () => void;
}

const WelcomeContent = ({ onAdd }: WelcomeContentProps) => (
    <Stack vertical spacing="400" itemAlignment="center">
        <Title level={2} align="center">
            <LocalizedText textKey={TextKey.AddSenderAddress} />
        </Title>
        <StackItem>
            <EmailImage />
        </StackItem>
        <Body align="center">
            <LocalizedText textKey={TextKey.AddSenderAddressDescription} />
        </Body>
        <Body align="center">
            <Button variant="primary" icon={IconName.PlusSimple} onClick={onAdd} type="submit">
                <LocalizedText textKey={TextKey.Add} />
            </Button>
        </Body>
    </Stack>
);
